angular
    .module("topline.modules")
    .component("periodsPartial", {
        bindings: { config: "<", actions: "<", serverOperation: "<" },
        template: require("./periods.html")
    });
